import React, { useEffect } from 'react';
import { useLocation } from '../util/router';
import { getFuelAppUrl } from '../util/cross-app-urls';

/**
 * Redirects to Fuel routes
 * This component handles redirects from InsightSQC to Fuel for routes that belong to Fuel
 */
function FuelRedirect({ targetPath }) {
  const location = useLocation();

  useEffect(() => {
    const fuelUrl = getFuelAppUrl();

    if (fuelUrl) {
      // Use the provided targetPath or current path
      const path = targetPath || location.pathname;
      // Preserve query string if present
      const queryString = location.search || '';
      // Redirect to Fuel
      window.location.href = `${fuelUrl}${path}${queryString}`;
    } else {
      // Fallback: redirect to home if Fuel URL cannot be determined
      window.location.href = '/';
    }
  }, [location.pathname, location.search, targetPath]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        gap: '1rem'
      }}
    >
      <div className="spinner-border" role="status">
        <span className="sr-only">Loading...</span>
      </div>
      <p>Redirecting to Fuel...</p>
    </div>
  );
}

export default FuelRedirect;
